module.exports = __webpack_public_path__ + "static/media/NeuzeitGroLig.9b1a3faf.ttf";